import React, { useState, useEffect } from 'react';
import config from '../../config';
import { StaticPage, TopbarContainer } from '../../containers';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { propTypes } from '../../util/types';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { ContactUsForm } from '../../forms';
import { sendContactUsEmail } from '../../util/ses';
import get from 'lodash/get';

import css from './ContactPage.css';

const ContactPageComponent = ({ currentUser }) => {
  const intl = useIntl();
  const { siteFacebookPage, siteInstagramPage } = config;
  const [initialValues, setInitialValues] = useState({});
  const [sendMessageSuccess, setSendMessageSuccess] = useState(false);
  const [sendMessageInProgress, setSendMessageInPropgress] = useState(false);
  const [sendMessageError, setSendMessageError] = useState(null);

  const email = get(currentUser, 'attributes.email', null);

  useEffect(() => {
    if (email) {
      setInitialValues({ email: email });
    }
  }, [currentUser]);

  const handleSubmit = values => {
    setInitialValues(values);
    const { email, message, queryType, location } = values;
    const { selectedPlace } = location || {};
    const { address, origin } = selectedPlace || {};
    const subject = intl.formatMessage({
      id: `Config.queryType.${queryType}`,
    });
    if (!!email && !!(message || '').trim()) {
      setSendMessageInPropgress(true);
      setSendMessageSuccess(false);
      setSendMessageError(null);
      return sendContactUsEmail({
        ...values,
        subject,
        address,
        origin,
      })
        .then(() => {
          if (email) {
            setInitialValues({ email: email });
          }
          else {
            setInitialValues({});
          }

          setSendMessageSuccess(true);
          setSendMessageInPropgress(false);
        })
        .catch(error => {
          setSendMessageInPropgress(false);
          setSendMessageError(error);
        });
    }
    return Promise.resolve();
  };
  // prettier-ignore
  return (
    <StaticPage
      title="Contact Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ContactPage',
        description: 'Contact Us || Kindershare',
        name: 'Contact us page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div className={css.banner}>
            <h1 className={css.pageTitle}>
              <FormattedMessage id="ContactPage.pageTitle" />
            </h1>
          </div>

          <div className={css.contentWrapper}>

            <div className={css.contentMain}>

              <h2>
                <FormattedMessage id="ContactPage.contentTitle" />
              </h2>

              <p>
                <FormattedMessage id="ContactPage.contentDesc" />
              </p>

              <ExternalLink href="mailto:contact@kindershare.com">
                contact@kindershare.com
              </ExternalLink>

              <ContactUsForm
                initialValues={{ ...initialValues }}
                className={css.form}
                onSubmit={handleSubmit}
                submitInProgress={sendMessageInProgress}
                sendMessageSuccess={sendMessageSuccess}
                sendMessageError={sendMessageError}
                setSendMessageError={setSendMessageError}
                setSendMessageSuccess={setSendMessageSuccess}
              />

              <p>
                <FormattedMessage id="ContactPage.socialNetwork" />{' '}
                <ExternalLink href={siteFacebookPage}>Facebook</ExternalLink> and{' '}
                <ExternalLink href={siteInstagramPage}>Instagram</ExternalLink>.
              </p>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

ContactPageComponent.defaultProps = {
  currentUser: null,
};

ContactPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return {
    currentUser,
  };
};

const ContactPage = compose(connect(mapStateToProps))(ContactPageComponent);

export default ContactPage;
